import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface Unit {
  active: number;
  createdAt: any;
  name: string;
  type: string;
  symbol: string;
  value: string;
  reference: string;
  updatedAt: any;
}

export interface UnitId extends Unit {
  id: string;
}

@Injectable()
export class UnitService {

  collection: string;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    this.collection = Globals.UNIT_COLLECTION;
  }

  /**
   * Get all units with references
   * @return {Observable} Arrays of units
   */
  getUnits() {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get unit data
  * @param {string} sid - The id of the unit
  * @return {Observable} The Unit Object
  */
  getUnit(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new unit
  * @param {Unit} unit - The data of the unit
  */
  addUnit(unit: Unit) {
    function then(id){
      console.log(`uploaded unit ${id}`);
    }
    this.afh.add(`${this.collection}`, unit, then);
    this.router.navigate(['/unit']);
  }

  /**
   * Update current unit
   * @param {string} sid  - The id of the unit
   * @param {Unit} unit - The data of the unit
   */
  updateUnit(sid: string, unit: Unit) {
    this.afh.update(`${this.collection}/${sid}`, unit);
    this.router.navigate(['/unit']);
  }

  /**
   * Delete current unit
   * @param {string} sid - The id of the unit
   */
  deleteUnit(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  getDocRef(unitId: string){
    return this.afh.doc(`${this.collection}/${unitId}`).ref;
  }
}